import React from "react";
import FullScreenLoader from "UIComponents/FullScreenLoader";

/**
 * When there is only SettingsStep in edit mode (when click on re-assign), we open AddAssignment modal with transparent overlayContainer and modalContent
 * But with overlayContainer set to transparent, loader (withLoader in AddAssignment) appears without any overlay
 * And also loader (withLoader in ShareSettingsStep) does not appear
 * So we will show FullScreenLoader in this case and use this HOC in both AddAssignment and ShareSettingsStep component
 */
const WithOnlySettingStepHOC = WrappedComponent => {
  const WithOnlySettingStep = props => {
    const {
      mode,
      isData,
      isLoading,
      isSettingsStepOnly,
      isFromUnitPlan,
    } = props;
    return (isFromUnitPlan || mode === "edit") &&
      !isData &&
      isLoading &&
      isSettingsStepOnly ? (
      <FullScreenLoader />
    ) : (
      <WrappedComponent {...props} />
    );
  };
  return WithOnlySettingStep;
};

export default WithOnlySettingStepHOC;
